import { OrganizationCloseStage } from "@common/types/organizationCloseStage";
import { OrganizationTaskTemplate } from "@common/types/organizationTaskTemplate";
import type { ViewTableMeta } from "@hooks/view/useViewTableMeta";
import type { TaskTypeOption } from "../OrganizationCloseTemplates/closeTemplateTasksDrawer.constants";
import type { CloseTemplateTaskCallbacks } from "../OrganizationCloseTemplates/closeTemplateTasksViewConfig";

export type OrganizationTaskTemplateCallbacks = Pick<
    CloseTemplateTaskCallbacks,
    | "onEditTask"
    | "onUpdateAssigneeRole"
    | "onUpdateCloseStage"
    | "onUpdateDeadline"
    | "onUpdateDeadlineAnchor"
    | "onUpdateEstimatedTime"
> & {
    onArchiveTemplate: (templateId: string) => void;
    onUnarchiveTemplate: (templateId: string) => void;
    onDetachTemplate: (templateId: string) => void;
    onDeleteTemplate: (templateId: string) => void;
    onViewServiceTemplates: (templateId: string) => void;
    onOverrideKickDefault: (taskTypeOption: TaskTypeOption) => void;
};

export type OrganizationTaskTemplatesTableMeta = ViewTableMeta<
    OrganizationTaskTemplateCallbacks,
    never
> & {
    sortedStages: OrganizationCloseStage[];
    templatesById: ReadonlyMap<string, OrganizationTaskTemplate>;
    serviceTemplateCounts: Readonly<Record<string, number>>;
};

const isOrganizationTaskTemplatesTableMeta = (
    meta: object | undefined,
): meta is OrganizationTaskTemplatesTableMeta =>
    meta !== undefined &&
    "templatesById" in meta &&
    meta.templatesById instanceof Map &&
    "callbacks" in meta &&
    typeof meta.callbacks === "object" &&
    meta.callbacks !== null;

export const getOrganizationTaskTemplatesTableMeta = (table: {
    options: { meta?: object };
}): OrganizationTaskTemplatesTableMeta | null =>
    isOrganizationTaskTemplatesTableMeta(table.options.meta)
        ? table.options.meta
        : null;
